import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={16.704}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 79991 123072"
    {...props}
  >
    <path
      d="M3370 35249C5446 18591 19078 5160 35783 3314c10677-1180 20912 2079 28833 9176 7817 6999 12299 17026 12299 27510 0 9354-3506 18278-9873 25127-7520 8088-11663 18298-11663 28746v851h-6203V71101l9263-27629c194-581 26-1222-430-1633-457-409-1113-510-1669-253-10389 4762-22302 4762-32690 0-560-257-1213-156-1671 255-456 409-624 1051-429 1632l9263 27518v23733h-6202v-746c0-10810-3971-20875-11182-28343C5636 57565 1971 46490 3370 35249zm30440 35000-8269-24566c9343 3401 19570 3401 28913 0l-8275 24678c-52 158-79 324-79 489v23874H33890V70739c0-166-27-333-80-490zm21569 31293-30768-8v-3733h7580c106 11 215 11 322 0h22866v3741zm0 6812-30768-9v-3734l30768 8v3735zm0 3732c0 824-321 1596-901 2177-583 581-1354 900-2176 900h-2l-24612-6c-1698 0-3077-1380-3077-3076v-659l30768 9v655zm-10132 7008c-581 581-1354 901-2174 901h-1l-6154-7c-1223 0-2280-717-2776-1752l11710 4c-149 313-352 601-605 854zM21534 93978v18103c0 3391 2760 6153 6152 6153h3221c609 2760 3072 4831 6009 4831l6154 7h3c1642 0 3188-641 4350-1803 843-843 1413-1889 1661-3029h3218c1643 0 3189-639 4351-1801s1803-2708 1803-4353V96271c-2-7-2-7 0-9v-2389c0-9668 3849-19134 10839-26652 6899-7419 10696-17087 10696-27221 0-11357-4855-22220-13320-29803C58085 2508 46990-1019 35445 255 17340 2257 2566 16814 319 34869c-1517 12168 2456 24160 10897 32904 6655 6890 10318 16197 10318 26205z"
      style={{
        fill: "#1c1c1d",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
